export default "__VITE_ASSET__BkhmU$Cg__"